export class PurchaseConfig{
	PurchasesFromInboxreaderEnabled:boolean = false;
	PurchasesFromInboxreaderAllowedFroms:string[] = [];
	DefaultVatID:number = 0;
	RequireApprovalBeforeProcessing:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.PurchasesFromInboxreaderEnabled = data.PurchasesFromInboxreaderEnabled || false;
		this.PurchasesFromInboxreaderAllowedFroms = data.PurchasesFromInboxreaderAllowedFroms || [];
		this.DefaultVatID = data.DefaultVatID;
		this.RequireApprovalBeforeProcessing = data.RequireApprovalBeforeProcessing || false;
	}

	public getJSON(){
		return {
			PurchasesFromInboxreaderEnabled: this.PurchasesFromInboxreaderEnabled,
			PurchasesFromInboxreaderAllowedFroms: [...this.PurchasesFromInboxreaderAllowedFroms],
			DefaultVatID: this.DefaultVatID,
			RequireApprovalBeforeProcessing: this.RequireApprovalBeforeProcessing
		};
	}
}